import React from 'react';
import { useNavigate } from 'react-router-dom';
import { handleLogOut } from '../utils/clearCache';
import { ArrowLeft } from 'react-feather';
// import 'bootstrap/dist/css/bootstrap.min.css';

function NoAccessPage() {
  const navigate = useNavigate();

  return (
    <div>
      {/* Button at the top left */}
      <button
        className="btn position-absolute top-0 start-0 m-3"
        onClick={handleLogOut}
        style={{
          background: 'none',
          border: 'none',
          fontSize: '16px',
          fontFamily: 'Roboto, sans-serif',
          display: 'flex',
          alignItems: 'center',
          gap: '8px', // spacing between icon and text
          color: 'black',
          padding: 0,
        }}
      >
        <ArrowLeft size={24} color="black" />
        Back to Login
      </button>

      {/* Centered content */}
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <img
            src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/Mask+group.svg"
            alt="Placeholder"
            className="rounded-circle mb-2"
          />
          <h1
            className="h4 text-dark"
            style={{ fontWeight: 600 }} // Semi-bold
          >
            Permission Required
          </h1>
          <p
            className="lead"
            style={{ color: '#000', fontWeight: 400 }} // Black text and normal weight
          >
            Access unavailable at the moment. Contact admin for further
            assistance.
          </p>
        </div>
      </div>
    </div>
  );
}
export default NoAccessPage;
